export const pipe =
  (...fns: ((...args: any[]) => any)[]) =>
  (x: string) =>
    fns.reduce((v, f) => f(v), x)
